{
  "destinationSearch": {
    "calendarButton": "#Hintakalenteri#",
    "fromOrigin": "kohteesta {origin}"
  },
  "timetable": {
    "panel": {
      "title": "Aikataulut",
      "departure": "Lähtö",
      "return": "Paluu",
      "bookFlights": "Osta lennot"
    },
    "flightList": {
      "selectDepartureDate": "Valitse lähtöpäivä nähdäksesi aikataulun.",
      "selectReturnDate": "Valitse paluupäivä nähdäksesi aikataulun."
    }
  },
  "serviceForms": {
    "refundsCompensations": {
      "continue": "Continue",
      "newCase": "Create new case",
      "viewCase": "View existing cases",
      "infoAccordion": [
        {
          "title": "Eligible refund and compensation cases",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Documents needed for submitting a claim",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Gift voucher benefits",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    },
    "specialAssistanceWizard": {
      "infoAccordion": [
        {
          "title": "Accordion title 1",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 2",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        },
        {
          "title": "Accordion title 3",
          "content": "Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Sed posuere interdum sem. Quisque ligula eros ullamcorper quis, lacinia quis facilisis sed sapien."
        }
      ]
    }
  },
  "ticketSelection": {
    "travelClassAlternative": "Valitsemassasi matkustusluokassa ei löytynyt lentoja, joten tässä muita vaihtoehtoja."
  },
  "loginPromotion": {
    "loginHeading": {
      "inMmb": "Kirjaudu sisään ja kerää kaikki pisteesi"
    },
    "benefitText": "Kirjaudu sisään sähköpostillasi tai Finnair Plus-numerollasi.",
    "greeting": {
      "text": {
        "inPaxDetailsMulti": "We pre-filled your details based on your account. Please check them, then add the details for the other passengers."
      }
    }
  },
  "indiaRedirectNotification": "Hi! We redirected you to our international site from the Indian country site, which is temporarily closed for enhancements. You can book flights and use our services on this site as you would on the Indian one. We are sorry for any inconvenience.",
  "ondMarketing": {
    "breadcrumb": {
      "flights": "Flights",
      "fromCity": "From cities",
      "cityToCity": "City to city",
      "fromCountry": "From countries",
      "countryToCountry": "Country to country"
    },
    "heading": {
      "flights": "Discover our flights and routes",
      "fromCity": "Flights from cities",
      "cityToCity": "Explore more flights and destinations",
      "fromCountry": "Flights from countries",
      "countryToCountry": "Explore more flights and destinations"
    },
    "flightsFrom": "Flights from {origin}",
    "destinationFlightInfo": {
      "startingFrom": "Alkaen",
      "roundTrip": "Meno-paluu",
      "oneWay": "Yhdensuuntainen",
      "flightTime": "Lentoaika",
      "approx": "Noin",
      "airports": "Lentoasemat",
      "directFlights": "Suorat lennot"
    },
    "fromTo": "{origin}–{destination}"
  },
  "travelType": {
    "from": {
      "oneWay": "Meno kohteesta",
      "return": "Meno-paluu kohteesta"
    }
  }
}
